const removeNameSpace = (str) => {
  return String(str).replace(/\s/g, " ").toLowerCase().trim();
};

export default removeNameSpace;
